var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-single-signup-view",class:{
        'ls-single-signup-view--show-bg-image': _vm.showBg,
    }},[(!_vm.showBg)?[(_vm.isStandAloneTreatment)?_c('ls-header-brand'):_c('ls-header')]:_vm._e(),_c('ls-modals-container'),_c('transition',{attrs:{"name":"ls-fade","mode":"out-in","appear":""}},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }